import { render, staticRenderFns } from "./HangXachTay.vue?vue&type=template&id=44901daa&scoped=true&"
import script from "./HangXachTay.vue?vue&type=script&lang=js&"
export * from "./HangXachTay.vue?vue&type=script&lang=js&"
import style0 from "./HangXachTay.vue?vue&type=style&index=0&id=44901daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44901daa",
  null
  
)

export default component.exports